export default "__VITE_ASSET__CmY_LJBe__"